import { CSSProperties, useEffect, useState } from 'react';
import { DropdownFormFieldComponent, TextAreaFormFieldComponent, TextFormFieldComponent } from '@vivli/shared/components';
import { IDropdownMenuItem } from '@vivli/shared/infrastructure/interface';

import { EnquiryStatusEnum } from '@vivli/features/enquiry/infastructure/enum';
import { useActiveUserContext, useVivliConfigContext } from '@vivli/core/infrastructure/context';
import { useEnquiryContext } from '@vivli/features/enquiry/infastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

const twoColStyle: CSSProperties = {
    display: 'grid',
    justifyContent: 'space-around',
    gridTemplateColumns: '1fr 1fr',
    columnGap: '25px'
};
const containerStyle: CSSProperties = {
    paddingTop: '20px',
    display: 'grid',
    gridAutoRows: 'auto',
    rowGap: '20px'
};

export const EnquiryMainContainerComponent = () => {
    const [countryItems, setCountryItems] = useState<IDropdownMenuItem[]>();
    const vivliConfig = useVivliConfigContext();
    const { user, hasPermission } = useActiveUserContext();
    const { enquiry } = useEnquiryContext();
    const currentStatus = enquiry?.status ?? EnquiryStatusEnum.Draft;

    const isReadOnlyRequester = currentStatus !== EnquiryStatusEnum.Draft && enquiry?.requesterId === user.id;
    const isEditableRequesterName =
        hasPermission(PermissionsEnum.EnqActAdv) ||
        ((currentStatus === EnquiryStatusEnum.Draft || !enquiry?.id) && enquiry?.requesterId === user.id);

    useEffect(() => {
        if (vivliConfig?.countries?.length > 0) {
            const countryItems = vivliConfig.countries.map(({ name, code, numberSites }) => ({
                value: { name, code, numberSites },
                title: name
            }));
            setCountryItems(countryItems);
        }
    }, [vivliConfig]);

    return (
        <div style={containerStyle}>
            <div style={twoColStyle}>
                <TextFormFieldComponent name={'requesterEmail'} label={'Requester Email'} readonly={true}></TextFormFieldComponent>
                <TextFormFieldComponent
                    name={'requesterName'}
                    label={'Requester Name'}
                    readonly={!isEditableRequesterName}
                ></TextFormFieldComponent>
            </div>
            <div style={twoColStyle}>
                <TextFormFieldComponent
                    name={'requesterOrganization'}
                    label={'Your Institution'}
                    readonly={isReadOnlyRequester}
                ></TextFormFieldComponent>

                <DropdownFormFieldComponent
                    name={'requesterCountry'}
                    label={'Country'}
                    items={countryItems}
                    valueKey={`name`}
                    readonly={isReadOnlyRequester}
                ></DropdownFormFieldComponent>
            </div>
            <div style={twoColStyle}>
                <TextAreaFormFieldComponent
                    name={'enquiryPurpose'}
                    label={'Purpose'}
                    rows={3}
                    readonly={isReadOnlyRequester}
                ></TextAreaFormFieldComponent>

                <div>
                    The{' '}
                    <a target="_blank" href="http://vivli.org/members/ourmembers">
                        Vivli Members Page
                    </a>{' '}
                    provides information on each member and their policy for sharing datasets
                </div>
            </div>
        </div>
    );
};
